import ChallengeDetailInfo from './ChallengeDetailInfo';

export default ChallengeDetailInfo;
